(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // the sticky bar renders outside the section element, so match it on this section's id
    const stickyWrapper = document.querySelector(`.productV35StickyATCWrapper[data-product-sticky="${sectionID}"]`);

    // get product data
    const product = JSON.parse(section.querySelector(".productV35JSON").textContent);

    // the starting variant is determined in liquid (selected_or_first_available_variant); the tin selector
    // below swaps it to the 2-tin or 4-tin variant, and the selling selector toggles subscription vs one-time.
    let activeVariant = JSON.parse(section.querySelector(".productV35VariantJSON").textContent);
    let quantity = 1;

    // the "start now" block always adds the first variant, regardless of the selling selector
    const oneTimeVariant = product.variants[0];

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /**************
     Tin Selection
     ***************/

    // capture the "Save" label once so we can rebuild "Save $X" when the variant changes
    const saveElement = section.querySelector(".productV35SellingLabelBodyPriceSave");
    const saveLabel = saveElement ? saveElement.textContent.replace(/\$[\d.,]+/, "").trim() : "Save";

    // swap the active variant to the one matching the selected tin quantity (2 vs 4)
    function resolveVariant() {
        const tinInput = section.querySelector(".productV35DisplayItemInput:checked");
        if (!tinInput) {
            return;
        }
        const match = product.variants.find(variant => variant.options.includes(tinInput.value));
        if (match) {
            activeVariant = match;
        }
    }

    // a variant's own subscription allocations (each tin size lives in its own selling plan group)
    function getVariantSubAllocations(variant) {
        const allocations = variant.selling_plan_allocations || [];
        if (!subscriptionGroupIds.length) {
            return allocations;
        }
        return allocations.filter(allocation => subscriptionGroupIds.includes(allocation.selling_plan_group_id));
    }

    // find the subscription allocation for the active variant at the chosen frequency
    function getSubAllocation() {
        const allocations = getVariantSubAllocations(activeVariant);
        const planId = getSelectedPlanId();
        return allocations.find(allocation => allocation.selling_plan_id === planId) || allocations[0];
    }

    // refresh every price the tin selection affects: subscription card, one-time card, dosage, ongoing price
    function updatePrices() {
        const data = variantData[activeVariant.id] || {};

        // subscription card: compare, real, save, ongoing price bullet and dosage
        const subBody = section.querySelector(".productV35SellingLabelBody.sub");
        const subAllocation = getSubAllocation();
        if (subBody && subAllocation) {
            subBody.querySelector(".productV35SellingLabelBodyPriceAmountCompare").textContent = price(subAllocation.compare_at_price, true);
            subBody.querySelector(".productV35SellingLabelBodyPriceAmountReal").textContent = price(subAllocation.price, true);
            subBody.querySelector(".productV35SellingLabelBodyPriceSave").textContent = `${saveLabel} ${price(subAllocation.compare_at_price - subAllocation.price, true)}`;

            const subDosage = subBody.querySelector(".productV35SellingLabelBodyTopLeftDosageText");
            if (subDosage && data.dosageSub) {
                // dosage metafields contain markup (e.g. "<span>$1.13</span> per dose"), so render as HTML
                subDosage.innerHTML = data.dosageSub;
            }
        }

        // ongoing "/mo after first order" bullet
        const ongoingElement = section.querySelector(".productV35SellingLabelBodyBottomWrapContentBulletsItemSavePrice");
        if (ongoingElement && data.ongoing != null) {
            ongoingElement.textContent = `${price(data.ongoing, true)}/mo after first order`;
        }

        // one-time card: compare, real and dosage
        const onceBody = section.querySelector(".productV35SellingLabelBody.once");
        if (onceBody) {
            const onceCompare = onceBody.querySelector(".productV35SellingLabelBodyPriceAmountCompare");
            const onceReal = onceBody.querySelector(".productV35SellingLabelBodyPriceAmountReal");

            // only show the strike-through compare price when the variant is on sale
            if (activeVariant.compare_at_price > activeVariant.price) {
                onceCompare.textContent = price(activeVariant.compare_at_price, true);
                onceReal.classList.add("sale");
            } else {
                onceCompare.textContent = "";
                onceReal.classList.remove("sale");
            }
            onceReal.textContent = price(activeVariant.price, true);

            const onceDosage = onceBody.querySelector(".productV35SellingLabelBodyTopLeftDosageText.oneTime");
            if (onceDosage && data.dosageOnce) {
                // dosage metafields contain markup (e.g. "<span>$1.13</span> per dose"), so render as HTML
                onceDosage.innerHTML = data.dosageOnce;
            }
        }
    }

    /************
     Product Swiper
     ************/

    let thumbs = new Swiper(section.querySelector(".productV35VisualThumbs"), {
        slidesPerView: 5,
        spaceBetween: 4
    });

    const productSwiper = new Swiper(section.querySelector(".productV35VisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        thumbs: {swiper: thumbs},
        navigation: {
            prevEl: section.querySelector(".productV35VisualSwiperBtn.prev"),
            nextEl: section.querySelector(".productV35VisualSwiperBtn.next"),
        }
    });

    // Keep the active thumbnail always at the leftmost position
    productSwiper.on("slideChange", function () {
        thumbs.slideTo(productSwiper.realIndex);
    });


    // re-render whenever a selling radio or the frequency select changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateSelling();
        });
    })

    /**************
     Update Selling
     ***************/

    // the variant is already determined; this only reflects the chosen purchase mode (subscription vs one-time)
    function updateSelling() {
        // swap the active variant to match the selected tin quantity before rendering anything
        resolveVariant();

        // guard: the determined variant is unavailable
        if (!activeVariant) {
            section.querySelector(".productV35ATC").disabled = true;
            section.querySelector(".productV35ATC").textContent = "Not Available";
            return;
        }

        // sync the swiper to the variant's featured image
        if (activeVariant.featured_image) {
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        // rebuild the frequency options so the selling plan ids match the selected variant (they differ per variant)
        rebuildFrequencyOptions();

        // refresh the selling-card prices to match the selected tin quantity
        updatePrices();

        // read the chosen purchase mode from the sub radio (defaults to one-time if the selector isn't rendered)
        const subInput = section.querySelector(".productV35SellingLabelInput.sub");
        const isSub = subInput ? subInput.checked : false;

        // build the ATC text: subscription shows the per-month price, one-time shows the flat variant price
        let atcText;
        if (isSub) {
            // per-month figure comes from the variant metafield map; fall back to the subscription allocation price
            let perMonth = variantData[activeVariant.id]?.perMonth;
            if (perMonth == null) {
                perMonth = getSubAllocation()?.price;
            }
            atcText = `start my ritual - ${price(perMonth, true)}/mo`;
        } else {
            atcText = `start my ritual - ${price(activeVariant.price, true)}`;
        }

        // reflect availability + text on the main + sticky ATC buttons
        const stickyButton = stickyWrapper?.querySelector(".productV35StickyATCButton");
        if (activeVariant.available) {
            section.querySelector(".productV35ATC.sub").disabled = false;
            section.querySelector(".productV35ATC.sub").textContent = atcText;
            if (stickyButton) {
                stickyButton.disabled = false;
            }
        } else {
            section.querySelector(".productV35ATC").disabled = true;
            section.querySelector(".productV35ATC").textContent = "sold out";
            if (stickyButton) {
                stickyButton.disabled = true;
            }
        }


        //Update any ADD TO CART SECTION sections
        const ATCSxnExists = document.querySelector(".kappa.update") || false;
        if (ATCSxnExists && activeVariant.available) {
            document.querySelectorAll(".kappa.update").forEach(el => {
                el.disabled = false;
                el.textContent = atcText;
            })
        }

        // update the disclaimer discount percentage from the subscription selling plan (one-time has none)
        const sellingPlan = isSub ? getSellingPlanById(getSelectedPlanId()) : false;
        if (sellingPlan) {
            section.querySelectorAll('.productV35DisclaimerDiscount')?.forEach((element) => {
                element.textContent = Math.round(sellingPlan.price_adjustments[0].value) + "%";
            })
        }

        // payments form always reflects the determined variant
        const payInstallmentsInput = section.querySelector('.productV35PaymentsInput');
        const shopifyPaymentTerms = section.querySelector('shopify-payment-terms');
        if (payInstallmentsInput) {
            payInstallmentsInput.value = activeVariant.id;
        }
        if (shopifyPaymentTerms) {
            shopifyPaymentTerms.dataset.variantId = activeVariant.id;
            shopifyPaymentTerms.setAttribute('variant-id', activeVariant.id);
        }


        // keep the variant in the url so it survives a refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);

        // keep the sticky select in step with the selling selector
        syncStickySelect(isSub);
    }

    /**************
     Selling Plan / Frequency
     ***************/

    // the hidden native select holds the selling plan id sent to cart; the details element is its styled proxy
    const sellingPlanSelect = section.querySelector(".productV35SellingLabelBodyBottomWrapContentSelect");
    const frequency = section.querySelector(".productV35SellingFrequency");

    // track which variant the frequency options were built for so we only rebuild on an actual variant change
    let renderedFrequencyVariantId = null;

    // resolve the chosen selling plan id (frequency) from the select, defaulting to the variant's first sub plan
    function getSelectedPlanId() {
        if (sellingPlanSelect && sellingPlanSelect.value) {
            return parseInt(sellingPlanSelect.value);
        }
        return getVariantSubAllocations(activeVariant)[0]?.selling_plan_id;
    }

    // reflect the native select's current value in the styled summary label
    function updateFrequencyTitle() {
        if (!frequency || !sellingPlanSelect) {
            return;
        }
        const frequencyTitle = frequency.querySelector(".productV35SellingFrequencyTitleText");
        const selectedOption = sellingPlanSelect.options[sellingPlanSelect.selectedIndex];
        if (frequencyTitle && selectedOption) {
            frequencyTitle.textContent = selectedOption.textContent.trim();
        }
    }

    // (re)bind the freshly rendered frequency buttons back to the native select
    function bindFrequencyOptions() {
        if (!frequency || !sellingPlanSelect) {
            return;
        }
        const frequencyOptions = frequency.querySelectorAll(".productV35SellingFrequencyOptionsItem");
        frequencyOptions.forEach(option => {
            option.addEventListener("click", function () {
                // write the chosen plan back to the native select, mark it selected and close the dropdown
                sellingPlanSelect.value = option.dataset.value;
                frequencyOptions.forEach(opt => opt.classList.remove("selected"));
                option.classList.add("selected");
                frequency.removeAttribute("open");
                // re-render so the price + ATC reflect the chosen frequency
                updateSelling();
            });
        });
    }

    // rebuild the frequency options from the active variant's own selling plans (their ids differ per variant)
    function rebuildFrequencyOptions() {
        if (!sellingPlanSelect || activeVariant.id === renderedFrequencyVariantId) {
            return;
        }

        // keep the chosen frequency position when switching variants (2 tin -> 4 tin share the same intervals)
        const previousIndex = sellingPlanSelect.selectedIndex >= 0 ? sellingPlanSelect.selectedIndex : 0;
        const allocations = getVariantSubAllocations(activeVariant);

        // rebuild the native select that gets sent to cart
        let optionsHTML = "";
        allocations.forEach(allocation => {
            const plan = getSellingPlanById(allocation.selling_plan_id);
            const name = plan ? plan.name.replace(/\*/g, "") : "";
            optionsHTML += `<option value="${allocation.selling_plan_id}">${name}</option>`;
        });
        sellingPlanSelect.innerHTML = optionsHTML;

        // rebuild the styled frequency buttons
        const optionsWrap = section.querySelector(".productV35SellingFrequencyOptions");
        if (optionsWrap) {
            let buttonsHTML = "";
            allocations.forEach((allocation, index) => {
                const plan = getSellingPlanById(allocation.selling_plan_id);
                const name = plan ? plan.name.replace(/\*/g, "") : "";
                let selectedClass = "";
                if (index === previousIndex) {
                    selectedClass = " selected";
                }
                buttonsHTML += `<button type="button" class="productV35SellingFrequencyOptionsItem${selectedClass}" data-value="${allocation.selling_plan_id}">${name}</button>`;
            });
            optionsWrap.innerHTML = buttonsHTML;
        }

        // restore the chosen frequency, re-bind the new buttons and refresh the summary label
        sellingPlanSelect.selectedIndex = Math.min(previousIndex, sellingPlanSelect.options.length - 1);
        bindFrequencyOptions();
        updateFrequencyTitle();

        renderedFrequencyVariantId = activeVariant.id;
    }

    /**************
     Sticky Select
     ***************/

    // the sticky bar's select mirrors the selling selector and drives it on change
    const stickySelect = stickyWrapper?.querySelector(".productV35StickyATCSelect");

    // reflect the chosen purchase mode in the sticky select
    function syncStickySelect(isSub) {
        if (!stickySelect) {
            return;
        }
        stickySelect.value = isSub ? "sub" : "once";
    }

    // choosing a sticky option checks the matching section radio so all selling logic runs
    if (stickySelect) {
        stickySelect.addEventListener("change", function () {
            const radio = section.querySelector(`.productV35SellingLabelInput.${stickySelect.value}`);
            if (!radio) {
                return;
            }
            radio.checked = true;
            radio.dispatchEvent(new Event("change", {bubbles: true}));
        });
    }

    // on load, render the correct price + selected state
    updateSelling();

    /**************
     One-Time Variant
     ***************/

    // Alice sells subscriptions and one-time purchases as separate products, so a one-time purchase
    // adds a different variant id than the subscription. The swaps are hardcoded per product.
    function getOtpVariantId(variantId) {
        // happy-ending-x-dipsea: map each subscription variant to its one-time-purchase counterpart
        if (product.handle === "happy-ending-x-dipsea") {
            return variantId === 43316629635209 ? 41711203844233 : 41711203877001;
        }
        // fall back to the variant's one_time_purchase_swap metafield map, else the variant itself
        return variantSwapMap[variantId] || variantId;
    }

    /**************
     Product ATC
     ***************/
    document.querySelectorAll('.productV35ATC').forEach(function (button) {
        button.addEventListener("click", async function () {

            // add loading animation to both buttons
            button.classList.add("loading");

            let formData = {
                items: [{
                    quantity: quantity,
                    id: activeVariant.id,
                }]
            };

            // the determined variant ships as a subscription or a one-time purchase based on the selling selector
            const isSub = section.querySelector('.productV35SellingLabelInput.sub')?.checked;
            if (isSub) {
                // subscription: attach the chosen selling plan (frequency)
                formData.items[0].selling_plan = getSelectedPlanId();
            } else {
                // one-time: no selling plan, add the separate one-time-purchase product variant
                formData.items[0].id = getOtpVariantId(activeVariant.id);
            }

            // add product
            await addProduct(formData);

            // remove loading animation
            button.classList.remove("loading");

            // open cart
            await openCart();
        })
    });

    /**************
     Start Now ATC
     ***************/
    // the "start now" block always adds the first variant (the button copy + selling plan are rendered from product.variants.first in liquid)
    section.querySelectorAll('.productV35StartBtnsItem').forEach(function (button) {
        button.addEventListener("click", async function () {

            // add loading animation
            button.classList.add("loading");

            let formData = {
                items: [{
                    quantity: quantity,
                    id: oneTimeVariant.id,
                }]
            };

            if (button.classList.contains("sub")) {
                // subscription: add the first variant with its selling plan
                formData.items[0].selling_plan = parseInt(button.dataset.plan);
            } else {
                // one-time: add the first variant's separate one-time-purchase product variant
                formData.items[0].id = getOtpVariantId(oneTimeVariant.id);
            }

            // add product
            await addProduct(formData);

            // remove loading animation
            button.classList.remove("loading");

            // open cart
            await openCart();
        })
    });

    // font fix override for shopify payments (make b element normal weight)
    customElements.whenDefined("shopify-payment-terms").then(() => {
        customElements.whenDefined("shop-pay-installments-banner").then(() => {
            // the element is absent on products without installments, so bail out rather than throw
            const bannerBold = section.querySelector("shopify-payment-terms")?.shadowRoot?.querySelector("shop-pay-installments-banner")?.shadowRoot?.querySelector("b");
            if (!bannerBold) {
                return;
            }
            bannerBold.style = "font-weight: 400;";
        });
    });

    // listen for all links to #product and scroll to this section
    document.querySelectorAll('a[href="#productV35"]').forEach(link => {
        link.addEventListener("click", function (e) {
            e.preventDefault();
            document.querySelector(".productV35").scrollIntoView({behavior: "smooth"});
        })
    })

    // scroll to reviews
    section.querySelectorAll('.productV35Reviews').forEach(button => {
        button.addEventListener("click", function () {
            let reviewsSection = document.querySelector('.okeReviews') || false;
            if (reviewsSection) {
                reviewsSection.scrollIntoView({behavior: "smooth"});
            }
        })
    })

    // several product sections can share a page, only the first bar whose section is rendered may show
    function ownsSticky() {
        const owner = [...document.querySelectorAll("[data-product-sticky]")].find(bar => {
            const barSection = document.querySelector(`[data-section="${bar.dataset.productSticky}"], [id="${bar.dataset.productSticky}"]`);
            return barSection && barSection.offsetParent !== null;
        });
        return owner != null && owner.dataset.productSticky === sectionID;
    }

    // listen for the ATC to go out of screen
    const fixedATC = section.querySelector(".productV35ATC.sub");
    window.addEventListener("scroll", (e) => {
        if (!stickyWrapper) {
            return;
        }

        //SHOW THE STICKY BUTTON BEFORE AND AFTER ON MOBILE
        if (window.innerWidth < 800) {
            if ((fixedATC.getBoundingClientRect().top <= 0 || fixedATC.getBoundingClientRect().bottom > window.innerHeight) && ownsSticky()) {
                stickyWrapper.classList.add("visible");
            } else {
                stickyWrapper.classList.remove("visible");
            }
        } else {
            //ONLY SHOW THE STICKY BUTTON AFTER THE PRODUCT PDP HAS SCROLLED PAST
            if (fixedATC.getBoundingClientRect().top <= 0 && ownsSticky()) {
                stickyWrapper.classList.add("visible");
            } else {
                stickyWrapper.classList.remove("visible");
            }
        }
    });

    /**
     * Given a selling plan id, find the master selling plan object
     * @param {number} sellingPlanId
     * @returns {Object}
     */
    function getSellingPlanById(sellingPlanId) {
        let sellingPlan = null;
        product.selling_plan_groups.forEach(group => {
            group.selling_plans.forEach(plan => {
                if (plan.id === sellingPlanId) {
                    sellingPlan = plan;
                }
            });
        });
        return sellingPlan;
    }


}());